import React from 'react';
interface Option {
  value: string;
  label: string;
  icon?: React.ReactNode;
}
interface SegmentedControlProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  ariaLabel?: string;
}
export function SegmentedControl({
  options,
  value,
  onChange,
  className = '',
  ariaLabel = 'Options'
}: SegmentedControlProps) {
  return <div role="radiogroup" aria-label={ariaLabel} className={`inline-flex rounded-md shadow-sm bg-gray-100 p-1 ${className}`} data-id="element-15138">
      {options.map(option => {
      const selected = value === option.value;
      return <button key={option.value} type="button" role="radio" aria-checked={selected} onClick={() => onChange(option.value)} className={`flex items-center px-4 py-2 text-sm font-medium rounded-md transition-all ${selected ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-15139">
            {option.icon && <span className="mr-2" aria-hidden="true" data-id="element-15140">
                {option.icon}
              </span>}
            {option.label}
          </button>;
    })}
    </div>;
}